import PrescriptionList from "../PrescriptionList/PrescriptionList";

export default function ClientPrescriptionsViewWrapper() {
    return <PrescriptionList />;
}
